import { createAction } from 'redux-actions';
import * as ActionTypes from '../actionTypes/firepanel';

export const setFirePanelStatus = createAction(ActionTypes.SET_FIRE_PANEL_STATUS);
export const setFirePanelList = createAction(ActionTypes.SET_FIRE_PANEL_LIST);
